export default __webpack_public_path__ + "static/media/Gwent-Mod1-ParticipantGuide.5ba88537.pdf";